import { Link, useParams } from "react-router-dom";
import { adminProcApi } from "../../api";
import { ProcError, ProcField, ProcForm, ProcGrid, ProcLoading, ProcSection } from "../../components/ProcurementLayout";
import { ProcStatusBadge } from "../../components/ProcStatusBadge";
import { useAsyncData } from "../../hooks";

const RATING_LABELS: Record<number, string> = { 1: "Very Poor", 2: "Poor", 3: "Fair", 4: "Good", 5: "Excellent" };

export default function FeedbackViewPage() {
  const { id } = useParams<{ id: string }>();

  const { data: fb, loading, error } = useAsyncData(
    () => adminProcApi.getFeedback(Number(id)),
    [id],
  );

  if (loading) return <ProcLoading />;
  if (error) return <ProcError message={error} />;
  if (!fb) return null;

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <Link to="/procurement/admin/feedback" className="text-sm text-emerald-700 hover:underline">&larr; Back to Feedback</Link>
      </div>

      <ProcForm formNo="PROC-FRM-13" title="Department User Feedback" serialNo={fb.serialNo} date={fb.date}>
        <ProcSection title="Feedback Details">
          <ProcGrid>
            <ProcField label="Department" value={fb.departmentName ?? String(fb.departmentId)} />
            <ProcField label="Supplier" value={fb.supplierName} />
            <ProcField label="Feedback Type" value={<ProcStatusBadge value={fb.feedbackType} />} />
            <ProcField label="Rating" value={`${fb.ratingScore}/5 — ${RATING_LABELS[fb.ratingScore] ?? ""}`} />
            <ProcField label="Linked Requisition" value={fb.requisitionSerialNo ?? (fb.requisitionId ? String(fb.requisitionId) : "—")} />
            <ProcField label="Submitted By" value={fb.submittedByUsername ?? "—"} />
            <ProcField label="Description" value={fb.description} span2 />
            {fb.recommendations && <ProcField label="Recommendations" value={fb.recommendations} span2 />}
          </ProcGrid>
        </ProcSection>
      </ProcForm>
    </div>
  );
}
